module.exports = __webpack_public_path__ + "img/036-sign language.dc75690a.svg";